import { GridsterItemConfig } from 'angular-gridster2';

import { FieldTypeEnum } from '@models/module/fields/enums';
import { FieldModel, ScreenFieldModel } from '@models/module/fields/main';

export interface DesignerItem extends GridsterItemConfig {
  uid: string;
  field: ScreenFieldModel;
  unknownType?: boolean;
}

export interface DesignerLayoutEntry {
  uid: string;
  x: number;
  y: number;
  cols: number;
  rows: number;
  annotation?: string;
}

export interface TableColumnModel extends FieldModel {
  width?: number;
  position?: number;
}

export interface DeletedTableColumn {
  id: number;
  name: string;
  label: string;
  hasMultipleValues: boolean;
  typeId?: number;
  displayTypeId?: number;
  width?: number;
}

export interface SyncTableColumnsPayload {
  id: number;
  fields: { id: number; width: number; position: number }[];
}

export interface ListElementModel {
  id: string;
  name?: string;
  fullName?: string;
}

export interface ListElementsRequest {
  id: number;
  parentElementIds?: number[];
  parentListId?: number;
}

export interface FieldSearchParams {
  screenId: number;
  entityId: number;
  addContractFields: boolean;
  includeSystemFields?: boolean;
}

export const ANNOTATION_UID_PREFIX = 'annotation-';

export const designerUid = (field: ScreenFieldModel, index: number): string =>
  field.id && field.typeId !== FieldTypeEnum.Annotation
    ? `field-${field.id}`
    : `${ANNOTATION_UID_PREFIX}${field.id ?? 'new'}-${index}`;

export const layoutOf = (items: DesignerItem[]): DesignerLayoutEntry[] =>
  items
    .map(({ uid, x, y, cols, rows, field }) => ({ uid, x, y, cols, rows, annotation: field.annotation }))
    .sort((a, b) => a.uid.localeCompare(b.uid));
